module.exports = __webpack_public_path__ + "media/images/orion_pictos/orion-svg-sprite-theme-7bf0f0b52493bfdd3b705442a1b2b51f.svg";